<!-- mettal-3\src\components\View692.vue -->
<template>
  <div class="view-191">
    <img
      class="vector-4-1"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-4-1.svg"
      alt="Vector 4"
    />
  </div>
</template>

<script>
export default {
  name: "View692",
};
</script>

<style>
.view-191,
.view-192 {
  aspect-ratio: 1;
  background-color: var(--azure-radiance);
  border-radius: 7.5px;
  display: flex;
  height: 15px;
  justify-content: center;
  left: 253px;
  position: absolute;
  top: 0;
  width: 15px;
}

.vector-4-1,
.vector-4-2 {
  height: 7.77px;
  margin-left: 0.8px;
  margin-top: 4.2px;
  width: 8.75px;
}
</style>
